import { useEffect, useRef } from "react";

interface Props {
  siteKey: string;
  theme: "light" | "dark";
  onVerify: (token: string) => void;
}

const TurnstileWidget = ({ siteKey, theme, onVerify }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const widgetIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!window.turnstile || !containerRef.current) return;

    // Render only ONCE
    if (!widgetIdRef.current) {
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: siteKey,
        theme,
        callback: (token: string) => {
          console.log("TOKEN:", token);
          onVerify(token);
        },
        "expired-callback": () => {
          onVerify("");
        },
      });
    }

    return () => {
      if (widgetIdRef.current && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
        widgetIdRef.current = null;
      }
    };
  }, []); // ❌ remove dependencies

  return <div ref={containerRef} />;
};

export default TurnstileWidget;